import type { TFunction } from 'i18next';
import { Fragment } from 'react';
import { STATUS_MARKS } from '../../utils/statusTonePalette.ts';
import { getWidgetNotices } from '../../utils/widgetNotices.ts';
import { getPersonaSections, getPersonasDisclaimer, hasPersonasDisclaimer } from '../utils/personaSections.ts';
import { getPersonaTone, parsePersonasPayload } from '../utils/personasPayload.ts';

type OpenXAgentTargetingCopyPersonasProps = {
  payload: unknown;
  t: TFunction;
};

export const OpenXAgentTargetingCopyPersonas = ({ payload, t }: OpenXAgentTargetingCopyPersonasProps) => {
  const parsed = parsePersonasPayload(payload);
  if (!parsed.ok) return <p>{getWidgetNotices(t).errorNotice}</p>;

  const disclaimer = getPersonasDisclaimer(t);

  return (
    <div>
      {hasPersonasDisclaimer(parsed.value.personas) ? (
        <p>
          <strong>{disclaimer.label}</strong> {disclaimer.text}
        </p>
      ) : null}
      {getPersonaSections(parsed.value.personas, t).map(section => (
        <Fragment key={section.status}>
          <p>
            <strong>{section.title}</strong>
            <br />
            {section.caption}
          </p>
          {section.personas.map(persona => (
            <p key={persona.id}>
              {`${STATUS_MARKS[getPersonaTone(persona.status)]} `}
              <strong>{persona.title}</strong>
              {persona.description ? (
                <>
                  <br />
                  {persona.description}
                </>
              ) : null}
              {persona.reasons ? (
                <>
                  <br />
                  {persona.reasons}
                </>
              ) : null}
            </p>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
